module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerPanel row"
  }, [_c('div', {
    staticClass: "profileContainer"
  }, [_c('div', {
    staticClass: "profileImg"
  }), _vm._v(" "), _c('span', {
    staticClass: "profileName"
  }, [_vm._v("\n      " + _vm._s(_vm.username)), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "closePanel close-panel"
  }, [_c('f7-icon', {
    staticClass: "imgClosePanel close-panel",
    attrs: {
      "icon": _vm.isWhite()
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02ed753a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ed753a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/MobileMenuComponents/MobileIdentityHeader.vue
// module id = 2315
// module chunks = 2